import * as React from 'react';

const ArrowBack12 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 12 12", width: 12, height: 12, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M7 3H5V1L1 3.75 5 6.5v-2h2a2.5 2.5 0 0 1 0 5H1V11h6a4 4 0 0 0 0-8" }));
ArrowBack12.Size = 12;
ArrowBack12.Title = "ArrowBack";

export { ArrowBack12 as default };
